import { Typography } from "@mui/material";
import { ResponsiveContainer } from "recharts";

export default function BioGraficoPainel({ media, fullName, nomeAgrupador }) {
    return (
        <>
            <ResponsiveContainer width={'100%'} height={300} /*className="rounded-bar-chart"*/>
                <div style={{ width: '100%', height: '100%', fontSize: '72px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                    {(media / 1000).toFixed(0) + " ton"}
                </div>
            </ResponsiveContainer>

            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'h6'}>{fullName}</Typography>
            <Typography sx={{ textAlign: 'center', fontFamily: 'sans-serif' }} variant={'caption'}>por {nomeAgrupador}</Typography>
        </>
    )
}